// angular import
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Project import
import { GuestLayoutComponent } from './theme/layouts/guest-layout/guest-layout.component';
import { AuthGuard, NoAuthGuard } from './services/auth.guard';
import { DashboardRedirectGuard } from './services/dashboard-redirect.guard';

const routes: Routes = [
  // ========== PUBLIC ROUTES ==========
  // Main landing page - public
  {
    path: '',
    loadComponent: () => import('./main/main-page-component').then((c) => c.MainPageComponent),
    pathMatch: 'full',
    title: 'MCP Web Registration'
  },
  {
    path: 'main-page',
    loadComponent: () => import('./main/main-page-component').then((c) => c.MainPageComponent),
    title: 'MCP Web Registration'
  },
  // Registration page - public
  {
    path: 'registration',
    loadComponent: () => import('./registration/registration-page-component').then((c) => c.RegistrationPageComponent),
    title: 'Registration - MCP'
  },

  // ========== AUTH ROUTES ==========
  // Auth routes - only for non-authenticated users
  {
    path: 'auth',
    component: GuestLayoutComponent,
    canActivate: [NoAuthGuard],
    children: [
      {
        path: 'login',
        loadComponent: () => import('./demo/pages/authentication/auth-login/auth-login.component').then((c) => c.AuthLoginComponent),
        title: 'Login - MCP'
      },
      {
        path: 'verify-otp',
        loadComponent: () => import('./demo/pages/authentication/auth-otp/auth-otp.component').then((c) => c.AuthOtpComponent),
        title: 'Verify OTP - MCP'
      }
    ]
  },

  // ========== FEATURE MODULES (LAZY LOADED) ==========
  // Admin module - separate layout with blue theme
  {
    path: 'admin',
    loadChildren: () => import('./features/admin/admin.routes').then((m) => m.ADMIN_ROUTES),
    canActivate: [AuthGuard]
  },
  // Reseller module - separate layout with green theme
  {
    path: 'reseller',
    loadChildren: () => import('./features/reseller/reseller.routes').then((m) => m.RESELLER_ROUTES),
    canActivate: [AuthGuard]
  },
  // Agent/Customer module - separate layout with orange theme
  {
    path: 'agent',
    loadChildren: () => import('./features/agent/agent.routes').then((m) => m.AGENT_ROUTES),
    canActivate: [AuthGuard]
  },

  // ========== SMART REDIRECTS ==========
  // Smart dashboard redirect - redirects based on role
  {
    path: 'dashboard',
    canActivate: [AuthGuard, DashboardRedirectGuard],
    children: []
  },

  // ========== LEGACY ROUTE REDIRECTS ==========
  { path: 'login', redirectTo: 'auth/login', pathMatch: 'full' },
  { path: 'verify-otp', redirectTo: 'auth/verify-otp', pathMatch: 'full' },
  { path: 'admin-dashboard', redirectTo: 'admin/dashboard', pathMatch: 'full' },
  { path: 'reseller-dashboard', redirectTo: 'reseller/dashboard', pathMatch: 'full' },
  { path: 'agent-dashboard', redirectTo: 'agent/dashboard', pathMatch: 'full' },
  { path: 'user-management', redirectTo: 'admin/users', pathMatch: 'full' },
  { path: 'reseller-management', redirectTo: 'admin/resellers', pathMatch: 'full' },
  { path: 'vessel-list', redirectTo: 'admin/vessels', pathMatch: 'full' },
  { path: 'vessels', redirectTo: 'admin/vessels', pathMatch: 'full' },
  { path: 'resellers', redirectTo: 'admin/resellers', pathMatch: 'full' },
  { path: 'settings', redirectTo: 'dashboard', pathMatch: 'full' },
  { path: 'reseller/my-users', redirectTo: 'reseller/users', pathMatch: 'full' },
  { path: 'reseller/add-user', redirectTo: 'reseller/users/add', pathMatch: 'full' },

  // ========== WILDCARD ==========
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
